module.exports = __webpack_public_path__ + "media/images/patterns/footer-mobile-cce9107dc3a76b593dc0832dcf49f0a2.svg";